import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-4 py-3 bg-primary/5 border-t border-border space-y-2" }
const _hoisted_2 = { class: "flex items-center justify-between text-sm text-muted-foreground" }
const _hoisted_3 = { class: "font-semibold text-foreground" }
const _hoisted_4 = { class: "flex items-center justify-between text-sm text-muted-foreground" }
const _hoisted_5 = { class: "font-semibold text-foreground" }
const _hoisted_6 = { class: "flex items-center justify-between pt-2 border-t border-border" }
const _hoisted_7 = { class: "font-bold text-primary text-lg" }

import { useCartStore } from '@/stores/cartStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'CartSummary',
  setup(__props) {

const cartStore = useCartStore();

const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "Items:", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(cartStore).itemCount), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("span", null, "Quantity:", -1)),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(cartStore).totalItems), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-semibold text-foreground" }, "Subtotal:", -1)),
      _createElementVNode("span", _hoisted_7, _toDisplayString(formatCurrency(_unref(cartStore).subtotal)), 1)
    ])
  ]))
}
}

})